import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { I18nProvider } from "@/i18n/I18nContext";
import { ConsentProvider } from "@/context/ConsentContext";
import { AuthProvider } from "@/context/AuthContext";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import Residence from "@/pages/Residence";
import Services from "@/pages/Services";
import MilieuDeVie from "@/pages/MilieuDeVie";
import Admission from "@/pages/Admission";
import Galerie from "@/pages/Galerie";
import FAQ from "@/pages/FAQ";
import Carrieres from "@/pages/Carrieres";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/legal/LegalPage";
import NotFound from "@/pages/NotFound";
import AdminPage from "@/pages/admin/AdminPage";
import RedirectTo from "@/components/RedirectTo";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <ConsentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin" element={<AdminPage />} />
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/la-residence" element={<Residence />} />
                <Route path="/services" element={<Services />} />
                <Route path="/milieu-de-vie" element={<MilieuDeVie />} />
                <Route path="/admission" element={<Admission />} />
                <Route path="/galerie" element={<Galerie />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/carrieres" element={<Carrieres />} />
                <Route path="/contact" element={<Contact />} />
                {/* legal */}
                <Route path="/politique-de-confidentialite" element={<LegalPage />} />
                <Route path="/politique-sur-les-temoins" element={<LegalPage />} />
                <Route path="/gouvernance-des-renseignements" element={<LegalPage />} />
                <Route path="/declaration-accessibilite" element={<LegalPage />} />
                <Route path="/conditions-utilisation" element={<LegalPage />} />
                {/* redirects table */}
                <Route path="/carriere" element={<RedirectTo to="/carrieres" />} />
                <Route path="/gallery" element={<RedirectTo to="/galerie" />} />
                <Route path="/contact-us" element={<RedirectTo to="/contact" />} />
                <Route path="/services-en" element={<RedirectTo to="/services" />} />
                <Route path="/accueil" element={<RedirectTo to="/" />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ConsentProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
